import React from "react";
import { Box, Flex, Input, InputProps } from "@chakra-ui/react";
import SVG from "react-inlinesvg";

interface Props {
  width?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onKeyDown?: () => void;
  inputProps?: InputProps;
}

function SearchInput({
  value,
  onChange,
  onKeyDown,
  width = "100%",
  placeholder = "",
  inputProps,
}: Props) {
  return (
    <Flex
      fontSize={"12px"}
      flexDirection={"row"}
      width={width}
      gap={"8px"}
      flexShrink={0}
    >
      <Box position={"relative"} width="100%">
        <SVG
          src={`/icons-v1_1/search.svg`}
          width={"20px"}
          height={"20px"}
          style={{
            position: "absolute",
            top: "50%",
            left: "6px",
            transform: "translateY(-50%)",
          }}
        />
        <Input
          padding={"0 8px"}
          margin={"0"}
          minHeight={"28px"}
          height={"auto"}
          fontSize={"inherit"}
          textAlign={"start"}
          paddingLeft={"26px"}
          value={value}
          paddingRight="26px"
          placeholder={placeholder}
          onChange={(event) => {
            //onChange(parseFloat(event.target.value));
            onChange(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              onKeyDown?.();
            }
          }}
          {...inputProps}
        />
        {value && (
          <Box
            width="20px"
            height="20px"
            cursor="pointer"
            position="absolute"
            top="50%"
            right="6px"
            transform="translateY(-50%)"
            zIndex={10}
          >
            <SVG
              src="/icons-v1_1/x-circle-solid.svg"
              width={"20px"}
              height={"20px"}
              onClick={() => {
                onChange("");
                if (onChange) {
                  onChange("");
                }
              }}
            />
          </Box>
        )}
      </Box>
    </Flex>
  );
}

export default SearchInput;
